var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLarge = function SvgLarge(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 241 240"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#large_svg__a)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 120.5,
    cy: 119.5,
    r: 119.5,
    fill: "#E84C15"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 120.5,
    cy: 119.5,
    r: 116.5,
    stroke: "#EFE6CC",
    strokeWidth: 6
  }))), /*#__PURE__*/React.createElement("path", {
    fill: "url(#large_svg__b)",
    d: "M1.41 109.201C-4.346 175.017 44.374 233.042 110.19 238.8s123.873-42.925 129.631-108.741S196.857 6.218 131.041.459C65.226-5.299 7.169 43.385 1.411 109.201",
    opacity: 0.3,
    style: {
      mixBlendMode: "hard-light"
    }
  }), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "large_svg__b",
    x1: -151.633,
    x2: -39.294,
    y1: -96.049,
    y2: 285.221,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#36363A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#3B3B3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#4B4B4E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#656568"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#89898B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#B7B7B8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.384,
    stopColor: "#E4E4E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.408,
    stopColor: "#DBDBDC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.431,
    stopColor: "#C5C5C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.451,
    stopColor: "#A1A1A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.481,
    stopColor: "#848486"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#5F5F63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#636367"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#707074"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#878789"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#98989A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#A5A5A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#C7C7C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#FDFDFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#848487"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#38383D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1B1B20"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "large_svg__a",
    width: 239.272,
    height: 239.272,
    x: 1,
    y: 0,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.272,
    dy: 0.272
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_828_55255"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_828_55255",
    result: "shape"
  })))));
};
export default SvgLarge;